export default [
  {
    // 热点图标列表
    name: '前进',
    frameImg: 'https://qnm.hunliji.com/o_1d566ilsfc6jkfcpuhsv52a99.png',
    icon: 'https://qnm.hunliji.com/o_1d4sg2drkvpf1j8cf6js40dpbg.png',
    animate: {
      width: 148,
      height: 148,
      rate: 12
    },
    mob: {
      w: 88,
      h: 88
    },
    pc: {
      w: 80,
      h: 80
    }
  },
  {
    name: '左转',
    frameImg: 'https://qnm.hunliji.com/o_1d5742vlrr451ul7tvo1hhi1tuud.png',
    icon: 'https://qnm.hunliji.com/o_1d4sg2drk1aom1aa8d4iccq1ltjf.png',
    animate: {
      width: 148,
      height: 148,
      rate: 12
    },
    mob: {
      w: 88,
      h: 88
    },
    pc: {
      w: 80,
      h: 80
    }
  },
  {
    name: '右转',
    frameImg: 'https://qnm.hunliji.com/o_1d5742vlr1lov1gmo1lo01ari6m4c.png',
    icon: 'https://qnm.hunliji.com/o_1d4sg2drkr3k1eh51r9ddhnu6oe.png',
    animate: {
      width: 148,
      height: 148,
      rate: 12
    },
    mob: {
      w: 88,
      h: 88
    },
    pc: {
      w: 80,
      h: 80
    }
  },
  {
    name: '热点',
    frameImg: 'https://qnm.hunliji.com/o_1d4ou9mn4p79a661647dvmcoc9.png',
    icon: 'https://qnm.hunliji.com/o_1d4sg2drkr371dmcn86ecc181h.png',
    animate: {
      width: 148,
      height: 148,
      rate: 12
    },
    mob: {
      w: 88,
      h: 88
    },
    pc: {
      w: 80,
      h: 80
    }
  },
  {
    name: '缩放',
    frameImg: 'https://qnm.hunliji.com/o_1d5742vlr123k17d61ljtfv9gn9b.png',
    icon: 'https://qnm.hunliji.com/o_1d4sg2drkl2dd3q1t9m1b66fhod.png',
    animate: {
      width: 148,
      height: 148,
      rate: 12
    },
    mob: {
      w: 88,
      h: 88
    },
    pc: {
      w: 80,
      h: 80
    }
  }
]
